import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <p class="mb-3 italic text-center">laŭ la melodio <span class="bold">«Staraja Melnica»</span></p>


    <div class="poem">
      <p class="poem-block mb-3">
        Kie plaŭdas maraj ondoj, <br/>
        Kie suno kvazaŭ flam’, <br/>
        Pasis, kiel la somero, <br/>
        Infaneco por ĉiam.
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Rado de la Fortun’ <br/>
        En la senĉesa turn’, <br/>
        Logas la homojn sukces’. <br/>
        Rado de la Fortun’, <br/>
        Gajno aŭ drasta pun’, <br/>
        Neplenumebla promes’.
      </p>

      <p class="poem-block mb-3">
        Mi postkuris la sukceson, <br/>
        Logis viva loteri’. <br/>
        En urbeg’ sen mar’, sen suno <br/>
        Nur pli alten strebis mi.
      </p>
      
      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf.</span>
      </p>

      <p class="poem-block refreno mb-3">
        Jen alvenis maljuneco, <br/>
        Kion mi atingis nun? <br/>
        Eĉ el alta kabineto <br/>
        Ne videblas flama sun’.
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Rado de la Fortun’'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['5RAcZwi_CRY'],
    itemTranslator: `
      Muziko: Jurij Nikolaev, <br/>
      ${translator.esp}
    `
  }
}

export default item;